import { useTranslation } from 'react-i18next'
import { PartnerReferral } from '../types'

interface PartnerReferralBoxProps {
  partner: PartnerReferral
}

const PartnerReferralBox = ({ partner }: PartnerReferralBoxProps) => {
  const { t, i18n } = useTranslation()
  const referralUrl = `${partner.url}&lang=${i18n.language}`

  return (
    <div className="partner-referral-box">
      <img className="partner-logo" src={partner.logoUrl} alt={partner.id} />
      <p className="partner-description">
        {t(`welcome.partnerReferral.${partner.id}.description` as 'welcome.partnerReferral.neo.description')}
      </p>
      <a href={referralUrl} className="btn-simple partner-cta">
        <span>{t(`welcome.partnerReferral.${partner.id}.cta` as 'welcome.partnerReferral.neo.cta')}</span>
        <i className="fa-regular fa-arrow-right" />
      </a>
    </div>
  )
}

export default PartnerReferralBox
